"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));
var _vue = _interopRequireDefault(require("vue"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _common = require("./common");
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/** @module */
var UserState = exports.default = /*#__PURE__*/function () {
  function UserState(user) {
    (0, _classCallCheck2.default)(this, UserState);
    this.key = user.nick.toUpperCase();
    this.nick = user.nick;
    this.host = user.host || '';
    this.username = user.username || '';
    this.realname = user.realname || '';
    this.modes = user.modes || [];
    this.away = user.away || '';
    this.colour = user.colour || '';
    this.account = user.account || '';
    this.buffers = Object.create(null);
    this.hasWhois = false;
    this.hasWhoFlags = false;
    this.typingState = Object.create(null);
    this.avatar = user.avatar || {
      small: '',
      large: ''
    };
    this.ignore = false;
    _vue.default.observable(this);

    // Whois details are non-enumerable properties (vues $watch won't cover these properties)
    // watch hasWhois to know when this data is populated
    (0, _common.def)(this, 'whois', {
      actual_ip: '',
      actual_username: '',
      actual_hostname: '',
      helpop: '',
      bot: '',
      server: '',
      server_info: '',
      operator: '',
      channels: '',
      modes: '',
      idle: '',
      logon: '',
      registered_nick: '',
      secure: '',
      special: ''
    }, true);

    // Who flags are non-enumerable properties (vues $watch won't cover these properties)
    // watch hasWhoFlags to know when this data is populated
    (0, _common.def)(this, 'whoFlags', {
      bot: null,
      operator: null,
      registered: null,
      secure: null
    }, true);
  }
  return (0, _createClass2.default)(UserState, [{
    key: "getColour",
    value: function getColour() {
      if (!this.colour) {
        this.colour = TextFormatting.createNickColour(this.nick);
      }
      // default will use the themes default text colour
      return this.colour === 'default' ? '' : this.colour;
    }
  }, {
    key: "isAway",
    value: function isAway() {
      return !!this.away;
    }
  }, {
    key: "typingStatus",
    value: function typingStatus(_target, status) {
      var _this = this;
      var target = _target.toUpperCase();
      if (!status) {
        return this.typingState[target] || {
          status: ''
        };
      }
      var typing = this.typingState[target];
      if (!typing) {
        _vue.default.set(this.typingState, target, {
          started: 0,
          status: ''
        });
        typing = this.typingState[target];
      }
      if (typing.timeout) {
        clearTimeout(typing.timeout);
        typing.timeout = null;
      }
      if (status === 'done') {
        _vue.default.delete(this.typingState, target);
        return null;
      }
      typing.started = Date.now();
      typing.status = status;

      // Paused state gets a longer timeout as it's usually someone stopping typing
      // to think about their words
      var timeoutLen = status === 'paused' ? 30000 : 6000;
      typing.timeout = setTimeout(function () {
        return _this.typingStatus(target, 'done');
      }, timeoutLen);
      return typing;
    }
  }]);
}();